import { StyleSpecification } from "maplibre-gl"

const maptilerKey = process.env.NEXT_PUBLIC_MAPTILER_API_KEY
export const SatelliteMapStyleJSON = {
    version: 8,
    id: "satellite",
    name: "Satellite",
    sources: {
        satellite: {
            url: `https://api.maptiler.com/tiles/satellite-v2/tiles.json?key=${maptilerKey}`,
            type: "raster",
        },
        maptiler_planet: {
            url: `https://api.maptiler.com/tiles/v3/tiles.json?key=${maptilerKey}`,
            type: "vector",
        },
        satellite_medimures: {
            url: `https://api.maptiler.com/tiles/satellite-mediumres-2021/tiles.json?key=${maptilerKey}`,
            type: "raster",
        },
        contours: {
            url: `https://api.maptiler.com/tiles/contours/tiles.json?key=${maptilerKey}`,
            type: "vector",
        },
        terrain: {
            url: `https://api.maptiler.com/tiles/terrain-rgb-v2/tiles.json?key=${maptilerKey}`,
            type: "raster-dem",
            tileSize: 512,
            maxzoom: 11,
        },
        openmaptiles: {
            url: `https://api.maptiler.com/tiles/v3/tiles.json?key=${maptilerKey}`,
            type: "vector",
        },
    },
    layers: [
        {
            id: "Satellite",
            type: "raster",
            source: "satellite",
            minzoom: 0,
            layout: {
                visibility: "visible",
            },
            paint: {
                "raster-opacity": 1,
            },
            filter: ["all"],
        },
        {
            id: "Satellite Mediumres 2021",
            type: "raster",
            source: "satellite_medimures",
            minzoom: 10,
            maxzoom: 13,
            layout: {
                visibility: "visible",
            },
            paint: {
                "raster-opacity": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    10,
                    0,
                    11,
                    1,
                    12.5,
                    1,
                    13,
                    0,
                ],
            },
        },
        {
            id: "Tunnel",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "transportation",
            layout: {
                "line-cap": "butt",
                "line-join": "miter",
                visibility: "none",
            },
            paint: {
                "line-color": "hsla(0, 0%, 100%, 0.2)",
                "line-width": ["interpolate", ["exponential", 1.5], ["zoom"], 6, 0.5, 20, 30],
                "line-dasharray": [0.28, 0.14],
            },
            filter: [
                "all",
                ["==", "$type", "LineString"],
                ["==", "brunnel", "tunnel"],
                ["in", "class", "motorway", "primary", "secondary", "tertiary", "trunk"],
            ],
        },
        {
            id: "Path",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "transportation",
            layout: {
                "line-cap": "square",
                "line-join": "bevel",
                visibility: "none",
            },
            paint: {
                "line-color": "hsla(0, 0%, 97%, 0.33)",
                "line-width": ["interpolate", ["exponential", 1.5], ["zoom"], 14, 0.5, 20, 4],
                "line-dasharray": [1, 1],
            },
            filter: ["all", ["==", "$type", "LineString"], ["in", "class", "path", "track"]],
        },
        {
            id: "Road",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "transportation",
            minzoom: 6,
            layout: {
                "line-cap": "butt",
                "line-join": "round",
                visibility: "none",
            },
            paint: {
                "line-color": {
                    stops: [
                        [8, "hsla(0, 0%, 100%, 0.2)"],
                        [14, "hsla(0, 0%, 100%, 0.4)"],
                        [18, "hsla(0, 0%, 100%, 0.5)"],
                    ],
                },
                "line-width": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    5,
                    ["match", ["get", "class"], ["motorway", "motorway_link"], 1, 0],
                    7,
                    ["match", ["get", "class"], ["motorway", "motorway_link", "trunk"], 1.4, 0],
                    8,
                    [
                        "match",
                        ["get", "class"],
                        ["motorway", "motorway_link", "primary", "trunk"],
                        0.75,
                        0,
                    ],
                    9,
                    ["match", ["get", "class"], ["secondary", "tertiary"], 0.7, 1],
                    10,
                    ["match", ["get", "class"], ["motorway", "motorway_link"], 1.3, 1.3],
                    14,
                    ["match", ["get", "class"], ["minor", "service"], 0.5, 2.4],
                ],
            },
            filter: [
                "all",
                ["==", "$type", "LineString"],
                ["!in", "class", "rail", "ferry", "path", "track"],
                ["!=", "brunnel", "tunnel"],
            ],
        },
        {
            id: "Railway",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "transportation",
            minzoom: 11,
            layout: {
                visibility: "none",
            },
            paint: {
                "line-color": "hsla(34, 12%, 66%, 0.2)",
                "line-opacity": ["interpolate", ["linear"], ["zoom"], 11, 0.5, 16, 1.3],
            },
            filter: ["==", "class", "rail"],
        },
        {
            id: "Other border",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "boundary",
            minzoom: 3,
            layout: {
                visibility: "none",
            },
            paint: {
                "line-color": "hsla(0, 0%, 76%, 0.5)",
                "line-dasharray": [2, 1],
            },
            filter: [
                "all",
                ["in", "admin_level", 3, 4, 5, 6, 7, 8],
                ["==", "maritime", 0],
                ["==", "disputed", 0],
            ],
        },
        {
            id: "Country dark border",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "boundary",
            layout: {
                "line-cap": "butt",
                "line-join": "round",
                visibility: "none",
            },
            paint: {
                "line-color": "hsla(0, 0%, 0%, 0.51)",
                "line-width": [
                    "interpolate",
                    ["exponential", 1.5],
                    ["zoom"],
                    3,
                    0.5,
                    9,
                    1.5,
                    22,
                    32,
                ],
                "line-offset": 1,
            },
            filter: ["all", ["==", "admin_level", 2], ["==", "maritime", 0], ["==", "disputed", 0]],
        },
        {
            id: "Disputed border",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "boundary",
            layout: {
                "line-cap": "round",
                "line-join": "round",
                visibility: "none",
            },
            paint: {
                "line-color": "hsl(0, 0%, 94%)",
                "line-width": [
                    "interpolate",
                    ["exponential", 1.5],
                    ["zoom"],
                    3,
                    0.5,
                    9,
                    1.5,
                    22,
                    32,
                ],
                "line-dasharray": [2, 4],
            },
            filter: [
                "all",
                ["\u003C=", "admin_level", 2],
                ["==", "maritime", 0],
                ["==", "disputed", 1],
            ],
        },
        {
            id: "Country border",
            type: "line",
            source: "maptiler_planet",
            "source-layer": "boundary",
            layout: {
                "line-cap": "round",
                "line-join": "round",
                visibility: "none",
            },
            paint: {
                "line-color": "hsl(0, 0%, 94%)",
                "line-width": [
                    "interpolate",
                    ["exponential", 1.5],
                    ["zoom"],
                    3,
                    0.5,
                    9,
                    1.5,
                    22,
                    32,
                ],
            },
            filter: ["all", ["==", "admin_level", 2], ["==", "maritime", 0], ["==", "disputed", 0]],
        },
        {
            id: "Road labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "transportation_name",
            minzoom: 14,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    14,
                    ["match", ["get", "class"], ["primary"], 10, 7],
                    15,
                    ["match", ["get", "class"], ["primary"], 10, ["secondary", "tertiary"], 9, 7],
                    16,
                    ["match", ["get", "class"], ["primary", "secondary", "tertiary"], 11, 10],
                    18,
                    ["match", ["get", "class"], ["primary", "secondary", "tertiary"], 13, 12],
                ],
                "text-field": ["coalesce", ["get", "name:en"], ["get", "name"]],
                visibility: "visible",
                "text-justify": "center",
                "symbol-spacing": {
                    stops: [
                        [6, 200],
                        [16, 250],
                        [20, 250],
                        [22, 600],
                    ],
                },
                "symbol-placement": "line",
                "symbol-avoid-edges": false,
                "text-letter-spacing": [
                    "interpolate",
                    ["linear", 1],
                    ["zoom"],
                    13,
                    0,
                    16,
                    ["match", ["get", "class"], "primary", 0.2, 0.1],
                ],
                "text-pitch-alignment": "auto",
                "text-rotation-alignment": "auto",
            },
            paint: {
                "text-color": "hsl(204, 11%, 47%)",
                "text-opacity": [
                    "step",
                    ["zoom"],
                    1,
                    14,
                    ["match", ["get", "class"], ["primary"], 1, 0],
                    15,
                    ["match", ["get", "class"], ["primary", "secondary", "tertiary"], 1, 0],
                    16,
                    1,
                ],
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0,0%,100%)",
                "text-halo-width": 1.5,
            },
            filter: ["in", "class", "primary", "secondary", "tertiary", "minor", "service"],
        },

        // START CONTOUR LABELS
        {
            id: "Contour index",
            type: "line",
            source: "contours",
            "source-layer": "contour",
            minzoom: 10,
            maxzoom: 22,
            layout: {
                visibility: "visible",
            },
            paint: {
                "line-color": "hsla(36, 45%, 90%, 0.8)",
                "line-width": ["interpolate", ["linear"], ["zoom"], 10, 0.8, 14, 1],
                "line-opacity": 0.25,
            },
            filter: ["all", ["in", "nth_line", 5, 10], ["!has", "glacier"]],
        },
        {
            id: "Glacier contour index",
            type: "line",
            source: "contours",
            "source-layer": "contour",
            minzoom: 10,
            maxzoom: 22,
            layout: {
                visibility: "visible",
            },
            paint: {
                "line-color": "hsla(200, 100%, 73%, 0.8)",
                "line-width": {
                    stops: [
                        [10, 0.8],
                        [14, 1.3],
                    ],
                },
                "line-opacity": 0.35,
            },
            filter: ["all", ["in", "nth_line", 5, 10], ["==", "glacier", 1]],
        },
        {
            id: "Contour",
            type: "line",
            source: "contours",
            "source-layer": "contour",
            minzoom: 11,
            maxzoom: 22,
            layout: {
                "line-cap": "square",
                visibility: "visible",
            },
            paint: {
                "line-color": "hsl(36, 45%, 80%)",
                "line-width": 1.2,
                "line-opacity": 0.2,
            },
            filter: ["all", ["!in", "nth_line", 5, 10], ["!has", "glacier"]],
        },
        {
            id: "Glacier contour",
            type: "line",
            source: "contours",
            "source-layer": "contour",
            minzoom: 11,
            maxzoom: 22,
            layout: {
                "line-cap": "square",
                visibility: "visible",
            },
            paint: {
                "line-color": "hsl(200, 100%, 80%)",
                "line-width": 0.8,
                "line-opacity": 0.3,
            },
            filter: ["all", ["!in", "nth_line", 5, 10], ["==", "glacier", 1]],
        },
        {
            id: "Glacier contour labels",
            type: "symbol",
            source: "contours",
            "source-layer": "contour",
            minzoom: 12,
            layout: {
                "text-font": ["Roboto Medium Italic", "Noto Sans Italic"],
                "text-size": {
                    base: 1,
                    stops: [
                        [12, 8],
                        [20, 12],
                    ],
                },
                "text-field": "{height}",
                visibility: "visible",
                "text-padding": 1,
                "symbol-placement": "line",
                "symbol-avoid-edges": true,
                "text-allow-overlap": false,
                "text-ignore-placement": false,
                "text-rotation-alignment": "map",
            },
            paint: {
                "icon-color": "hsl(0, 0%, 90%)",
                "text-color": "hsl(0, 0%, 90%)",
                "icon-opacity": 0.8,
                "text-opacity": 0.8,
                "text-halo-blur": 1,
                "icon-halo-color": "hsla(0, 0%, 20%, 0.8)",
                "icon-halo-width": 0.8,
                "text-halo-color": "hsla(0, 0%, 20%, 0.8)",
                "text-halo-width": 0.8,
            },
            metadata: {},
            filter: [
                "all",
                ["==", "$type", "LineString"],
                ["in", "nth_line", 10, 5],
                ["\u003E", "height", 0],
                ["has", "glacier"],
            ],
        },
        {
            id: "Contour labels",
            type: "symbol",
            source: "contours",
            "source-layer": "contour",
            minzoom: 12,
            layout: {
                "text-font": ["Roboto Medium Italic", "Noto Sans Italic"],
                "text-size": {
                    base: 1,
                    stops: [
                        [12, 8],
                        [20, 12],
                    ],
                },
                "text-field": "{height}",
                visibility: "visible",
                "text-padding": 1,
                "symbol-placement": "line",
                "symbol-avoid-edges": true,
                "text-allow-overlap": false,
                "text-ignore-placement": false,
                "text-rotation-alignment": "map",
            },
            paint: {
                "icon-color": "hsl(0, 0%, 90%)",
                "text-color": "hsl(0, 0%, 90%)",
                "icon-opacity": 0.8,
                "text-opacity": 0.8,
                "text-halo-blur": 1,
                "icon-halo-color": "hsla(0, 0%, 20%, 0.8)",
                "icon-halo-width": 0.8,
                "text-halo-color": "hsla(0, 0%, 20%, 0.8)",
                "text-halo-width": 0.8,
            },
            metadata: {},
            filter: [
                "all",
                ["==", "$type", "LineString"],
                ["\u003E", "height", 0],
                ["in", "nth_line", 5, 10],
                ["!has", "glacier"],
            ],
        },
        // END CONTOUR LABELS

        // ----- LABELS FROM LIGHT MAP SOURCE
        {
            id: "Ocean labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "water_name",
            minzoom: 0,
            maxzoom: 4,
            layout: {
                "text-font": ["Metropolis Semi Bold Italic", "Noto Sans Bold"],
                "text-size": ["interpolate", ["linear", 1], ["zoom"], 1, 11, 4, 14],
                "text-field": "{name:en}",
                visibility: "visible",
                "text-padding": 2,
                "text-max-width": 6,
                "text-transform": "uppercase",
                "symbol-placement": "point",
                "text-line-height": 1.2,
                "text-allow-overlap": false,
                "text-letter-spacing": 0.1,
                "text-pitch-alignment": "auto",
                "text-ignore-placement": false,
                "text-rotation-alignment": "auto",
            },
            paint: {
                "text-color": "hsl(190,9%,63%)",
                "text-opacity": [
                    "step",
                    ["zoom"],
                    0,
                    1,
                    ["match", ["get", "class"], ["ocean"], 1, 0],
                    4,
                    1,
                ],
            },
            filter: ["all", ["==", "class", "ocean"], ["has", "name"]],
        },
        {
            id: "Sea labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "water_name",
            minzoom: 3,
            maxzoom: 22,
            layout: {
                "text-font": ["Metropolis Semi Bold Italic", "Noto Sans Bold"],
                "text-size": ["interpolate", ["linear", 1], ["zoom"], 3, 9, 9, 16, 14, 20],
                "text-field": ["coalesce", ["get", "name:en"], ["get", "name"]],
                visibility: "visible",
                "text-padding": 2,
                "text-max-width": 6,
                "text-transform": "uppercase",
                "symbol-placement": "point",
                "text-line-height": 1.2,
                "text-allow-overlap": false,
                "text-letter-spacing": 0.1,
                "text-pitch-alignment": "auto",
                "text-ignore-placement": false,
                "text-rotation-alignment": "auto",
            },
            paint: {
                "text-color": "hsl(190,9%,63%)",
                "text-opacity": 1,
            },
            filter: ["all", ["==", "class", "sea"], ["has", "name"]],
        },
        {
            id: "Lakeline labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "water_name",
            layout: {
                "text-font": ["Metropolis Semi Bold Italic", "Noto Sans Bold"],
                "text-size": ["interpolate", ["linear"], ["zoom"], 9, 12, 14, 16, 18, 20],
                "text-field": ["coalesce", ["get", "name:en"], ["get", "name"]],
                visibility: "visible",
                "symbol-spacing": 350,
                "symbol-placement": "line",
                "text-line-height": 1.2,
                "text-pitch-alignment": "auto",
                "text-rotation-alignment": "auto",
            },
            paint: {
                "text-color": "hsl(190,9%,63%)",
            },
            filter: ["has", "name"],
        },
        {
            id: "Place labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "place",
            minzoom: 13,
            maxzoom: 22,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": [
                    "interpolate",
                    ["linear", 1],
                    ["zoom"],
                    12,
                    10,
                    13,
                    [
                        "match",
                        ["get", "class"],
                        ["suburb", "neighborhood", "neighbourhood"],
                        12,
                        11,
                    ],
                    14,
                    [
                        "match",
                        ["get", "class"],
                        ["suburb", "neighborhood", "neighbourhood"],
                        12,
                        11,
                    ],
                    16,
                    [
                        "match",
                        ["get", "class"],
                        ["suburb", "neighborhood", "neighbourhood"],
                        14,
                        13,
                    ],
                ],
                "text-field": ["coalesce", ["get", "name:en"], ["get", "name"]],
                visibility: "visible",
                "text-anchor": "center",
                "text-offset": [0.2, 0.2],
                "text-max-width": 10,
                "text-transform": "none",
                "text-keep-upright": true,
            },
            paint: {
                "text-color": "hsl(0, 0%, 90%)",
                "text-opacity": [
                    "step",
                    ["zoom"],
                    0,
                    13,
                    ["match", ["get", "class"], ["suburb", "neighborhood", "neighbourhood"], 1, 0],
                    14,
                    1,
                ],
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0, 0%, 20%)",
                "text-halo-width": 1.5,
            },
            filter: [
                "!in",
                "class",
                "city",
                "continent",
                "country",
                "province",
                "state",
                "town",
                "village",
            ],
        },
        {
            id: "Village labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "place",
            minzoom: 12,
            maxzoom: 22,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": [
                    "interpolate",
                    ["linear", 1],
                    ["zoom"],
                    12,
                    10,
                    13,
                    12,
                    14,
                    14,
                    16,
                    13,
                ],
                "text-field": "{name}",
                visibility: "visible",
                "text-anchor": "center",
                "text-offset": [0.2, 0.2],
                "text-max-width": 10,
                "text-transform": "none",
                "text-keep-upright": true,
            },
            paint: {
                "text-color": "hsl(204, 11%, 47%)",
                "text-opacity": 1,
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0, 0%, 100%)",
                "text-halo-width": 1.5,
            },
            filter: ["==", "class", "village"],
        },
        {
            id: "Town labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "place",
            minzoom: 11,
            maxzoom: 16,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": ["interpolate", ["linear"], ["zoom"], 10, 11, 13, 14, 14, 15],
                "text-field": ["coalesce", ["get", "name:en"], ["get", "name"]],
                visibility: "visible",
                "text-anchor": "center",
                "text-offset": [0.2, 0.2],
                "text-max-width": 10,
                "text-transform": "none",
                "text-keep-upright": true,
            },
            paint: {
                "text-color": "hsl(0, 0%, 90%)",
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0,0%,20%)",
                "text-halo-width": 1.5,
            },
            filter: ["==", "class", "town"],
        },
        {
            id: "State labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "place",
            minzoom: 5,
            maxzoom: 8,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": [
                    "interpolate",
                    ["linear", 1],
                    ["zoom"],
                    5,
                    ["match", ["get", "rank"], 1, 10, 10],
                    11,
                    ["match", ["get", "rank"], 1, 16, 16],
                ],
                "text-field": ["coalesce", ["get", "name:en"], ["get", "name"]],
                visibility: "visible",
                "text-max-width": 9,
                "text-transform": "uppercase",
                "text-allow-overlap": false,
            },
            paint: {
                "text-color": "hsl(0, 0%, 90%)",
                "text-opacity": [
                    "step",
                    ["zoom"],
                    0,
                    3,
                    ["match", ["get", "rank"], 1, 0.85, 0],
                    4,
                    ["case", ["\u003C=", ["get", "rank"], 1], 0.75, 0],
                    5,
                    ["case", ["\u003C=", ["get", "rank"], 3], 0.75, 0],
                    8,
                    ["match", ["get", "rank"], 4, 0.75, 0],
                    11,
                    0,
                ],
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0,0%,20%)",
                "text-halo-width": 1.5,
            },
            filter: ["all", ["==", "class", "state"], ["==", "rank", 1]],
        },
        {
            id: "City labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "place",
            minzoom: 5,
            maxzoom: 14,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": [
                    "interpolate",
                    ["linear", 1],
                    ["zoom"],
                    5,
                    ["case", ["\u003E=", ["get", "rank"], 6], 11, 12],
                    9,
                    ["case", ["\u003E=", ["get", "rank"], 6], 12, 14],
                    13,
                    ["case", ["\u003E=", ["get", "rank"], 6], 16, 18],
                    14,
                    ["case", ["\u003E=", ["get", "rank"], 6], 20, 22],
                ],
                "text-field": "{name:en}",
                visibility: "visible",
                "text-anchor": "center",
                "text-offset": [0.2, 0.2],
                "text-max-width": 10,
                "text-transform": "none",
                "symbol-sort-key": ["to-number", ["get", "rank"]],
                "text-keep-upright": false,
            },
            paint: {
                "text-color": "hsl(0, 0%, 90%)",
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0,0%,20%)",
                "text-halo-width": 1.5,
            },
            filter: ["all", ["==", "class", "city"], ["has", "rank"]],
        },
        {
            id: "Country labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "place",
            minzoom: 2,
            maxzoom: 10,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": [
                    "interpolate",
                    ["linear", 1],
                    ["zoom"],
                    2,
                    ["case", ["\u003C=", ["get", "rank"], 2], 11, 0],
                    3,
                    ["case", ["\u003C=", ["get", "rank"], 2], 11, 9],
                    4,
                    ["case", ["\u003C=", ["get", "rank"], 2], 12, 10],
                    5,
                    ["case", ["\u003C=", ["get", "rank"], 2], 13, 11],
                    6,
                    ["case", ["\u003C=", ["get", "rank"], 2], 14, 12],
                    7,
                    ["case", ["\u003C=", ["get", "rank"], 2], 14, 13],
                ],
                "text-field": "{name:en}",
                visibility: "visible",
                "text-transform": "uppercase",
            },
            paint: {
                "text-color": "hsl(0, 0%, 90%)",
                "text-opacity": [
                    "step",
                    ["zoom"],
                    1,
                    2,
                    ["case", ["\u003C=", ["get", "rank"], 2], 1, 0],
                    3,
                    1,
                ],
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0,0%,20%)",
                "text-halo-width": 1.5,
            },
            filter: ["all", ["==", "class", "country"], ["has", "iso_a2"]],
        },
        {
            id: "Continent labels",
            type: "symbol",
            source: "maptiler_planet",
            "source-layer": "place",
            minzoom: 0,
            maxzoom: 2,
            layout: {
                "text-font": ["Metropolis Semi Bold", "Noto Sans Bold"],
                "text-size": 13,
                "text-field": "{name:en}",
                visibility: "visible",
                "text-justify": "center",
                "text-max-width": 9,
                "text-transform": "uppercase",
                "text-keep-upright": false,
                "text-letter-spacing": 0.1,
            },
            paint: {
                "text-color": "hsl(0, 0%, 90%)",
                "text-halo-blur": 0,
                "text-halo-color": "hsl(0,0%,20%)",
                "text-halo-width": 1.5,
            },
            filter: ["==", "class", "continent"],
        },

        // _____ END MAP LABELS FROM LIGHT
        {
            id: "3d-buildings",
            source: "openmaptiles",
            "source-layer": "building",
            type: "fill-extrusion",
            minzoom: 15,
            paint: {
                "fill-extrusion-color": [
                    "interpolate",
                    ["linear"],
                    ["get", "render_height"],
                    0,
                    "lightgray",
                    200,
                    "royalblue",
                    400,
                    "lightblue",
                ],
                "fill-extrusion-height": [
                    "interpolate",
                    ["linear"],
                    ["zoom"],
                    15,
                    0,
                    16,
                    ["get", "render_height"],
                ],
                "fill-extrusion-base": [
                    "case",
                    [">=", ["get", "zoom"], 16],
                    ["get", "render_min_height"],
                    0,
                ],
            },
        },
    ],
    glyphs: `https://api.maptiler.com/fonts/{fontstack}/{range}.pbf?key=${maptilerKey}`,
    sprite: "https://api.maptiler.com/maps/satellite/sprite",
    terrain: {
        source: "terrain",
        exaggeration: 1,
    },
    bearing: 0,
    pitch: 0,
    center: [0, 0],
    zoom: 1,
} as StyleSpecification & { id: string }

export default SatelliteMapStyleJSON
